export * from './src/contacts-v4-submit-contact-submitted-contact.meta.js';
